import React from 'react';
import { useTranslation } from 'react-i18next';

import Icon from '../../../../../icons/Icon';
import { ICONS } from '../../../../../icons';

import scss from './Disclaimer.module.scss';

function Disclaimer() {
  const { t } = useTranslation('demoAdImages');

  return (
    <div className={scss.wrapper}>
      <Icon icon={ICONS.Info} disableCommonStyles disableCommonColors />
      <span>{t('disclaimerDemoRecreate')}</span>
    </div>
  );
}

export default Disclaimer;
